import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";

const ManualEventCertServiceApi = createApi({
    reducerPath: 'ManualEventCertServiceApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        GenerateManualEventAttendanceCert: builder.mutation({
            query: (details) => ({
                url: `/EventManagement/GenerateManualEventAttendanceCert`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useGenerateManualEventAttendanceCertMutation,
} = ManualEventCertServiceApi;

export default ManualEventCertServiceApi;